module.exports = __webpack_public_path__ + "static/media/pointing.1b9f4837.png";